/**
 * Marquee Banner Component
 *
 * A horizontally scrolling banner that displays repeated text.
 * The animation moves from right to left infinitely.
 */
export function MarqueeBanner() {
  const bannerText = "DESIGN & TECHNOLOGY • AI GENERATION • Pickle Salon •";

  return (
    <div className="w-full overflow-hidden border-b border-black/10 bg-white py-2">
      <div className="animate-marquee flex whitespace-nowrap">
        {Array(10)
          .fill(bannerText)
          .map((text, i) => (
            <span
              key={i}
              className="px-8 font-mono text-xs font-medium tracking-widest uppercase"
            >
              {text}
            </span>
          ))}
      </div>
    </div>
  );
}
